import { render } from "./NavbarGreenButton.vue?vue&type=template&id=3d053094&scoped=true"
import script from "./NavbarGreenButton.vue?vue&type=script&lang=js"
export * from "./NavbarGreenButton.vue?vue&type=script&lang=js"

import "./NavbarGreenButton.vue?vue&type=style&index=0&id=3d053094&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d053094"]])

export default __exports__